module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"password_field":"Пароль","login_button":"Войти","remember_checkbox":"Запомнить меня","reset_password":"Восстановить пароль"},"en":{"password_field":"Password","login_button":"Login","remember_checkbox":"Remember me","reset_password":"Reset password"}}')
  delete Component.options._Ctor
}
